export default "__VITE_ASSET__DH83AW7u__"